import { Button, ButtonProps } from 'antd';
import { useCallback, useEffect, useRef } from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { StatusMessages } from 'react-media-recorder-2';
import { PlayCircleOutlined, PauseCircleOutlined } from '@ant-design/icons';
import Flex from '../Flex';

export interface CaptureButtonProps {
  status: StatusMessages;
  mediaBlobUrl: string;
  onApply: (mediaBlobUrl: string) => void;
  startRecording: () => void;
  stopRecording: () => void;
  clearBlobUrl: () => void;
  time?: number;
  sendButtonProps?: ButtonProps;
}

const CaptureButton = ({
  time = 5000,
  status,
  onApply,
  startRecording,
  stopRecording,
  mediaBlobUrl,
  clearBlobUrl,
  sendButtonProps = {}
}: CaptureButtonProps) => {
  const timeoutRef = useRef(null);

  const handleStart = useCallback(() => {
    clearBlobUrl();
    startRecording();
    timeoutRef.current = setTimeout(stopRecording, time + 500);
  }, [stopRecording, startRecording]);

  useEffect(() => {
    return () => {
      stopRecording();
      if (timeoutRef.current != null) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <Flex
      justify="center"
      align="center"
      style={{
        width: 'calc(100% - 80px)',
        left: '50%',
        bottom: '0.75rem',
        position: 'absolute',
        transform: 'translateX(-50%)',
      }}>
      {mediaBlobUrl != null ?
        (
          <Flex className="w-full" direction="row">
            <Button
              size="middle"
              className="!text-sm w-full"
              onClick={() => onApply(mediaBlobUrl)} {...sendButtonProps}>ارسال ویدیو</Button>
            <Button
              danger
              size="middle"
              className="!text-sm flex items-center justify-center p-[0.65rem]"
              onClick={clearBlobUrl}
            >
              <DeleteOutlined />
            </Button>
          </Flex>
        ) : (
          status === 'recording' ?
            (
              <Flex align="center" justify="center" className="relative text-red-500 w-[50px] h-[50px]">
                <svg
                  style={{
                    width: 50,
                    height: 50,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    strokeDasharray: '126px',
                    strokeDashoffset: '126px',
                    strokeLinecap: 'round',
                    animation: `countdownCircle ${time}ms linear forwards`,
                  }}
                  className="absolute stroke-[2px] fill-none stroke-red-500">
                  <circle fill="none" r="20" cx="50%" cy="50%" />
                </svg>
                <PauseCircleOutlined style={{ fontSize: '32px' }} />
              </Flex>
            ) :
            <Flex className="text-nurture-darker" gap={4} direction="column" justify="center" align="center">
              <PlayCircleOutlined onClick={handleStart} className="text-3xl" />
              <span className="text-xs font-bold">شروع ضبط</span>
            </Flex>
        )}
    </Flex >
  );
};

export default CaptureButton;
